import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get, isNil} from 'lodash'
import {prefix} from 'helpers/component'
import iconNames from 'theme/icons'
import {getTaxCode} from 'containers/partPivotTable'
import Button from 'components/button'
import Icon from 'components/icon'
import {getPartType, nullPartCategory} from 'helpers/parts'
import {getTaxCodeOption} from 'helpers/taxCodes'
import FinancialHelper from 'helpers/financial'
import {getTitleForTotalItems} from 'helpers/string'
import {getPartCategoryActionsMenu} from "../treeSearcher/utils"
import './partCategoryDetails.scss'

class PartCategoryDetails extends Component {
  constructor(props) {
    super(props)
    this.getClass = prefix('part-category-details-')
  }

  getDefault = (name, value) => {
    return (
      <li>
        <div className={'name'}>{name}</div>
        <div className={'value'}>{value}</div>
      </li>
    )
  }

  getPartCategoryPartType = () => {
    const {partCategory, partTemplates} = this.props
    if (isNil(partCategory)) return null
    const partTemplate = partTemplates.find(t => t.id === partCategory.partTemplateId)
    return isNil(partTemplate)
      ? null
      : getPartType(partTemplate.partType)
  }

  getTaxCodeLabel = () => {
    const {partCategory, taxCodes} = this.props
    const taxCode = getTaxCode(get(partCategory, 'taxCodeId', null), taxCodes)
    return isNil(taxCode)
      ? 'Not Specified'
      : get(getTaxCodeOption(taxCode), 'label', null)
  }

  getMarkup = () => {
    const {partCategory} = this.props
    return isNil(partCategory.markup) || partCategory.markup === 0
      ? 'Not Specified'
      : FinancialHelper.getPercentageString(partCategory.markup)
  }

  render() {
    const {isExpanded, partCategory, totalParts, onToggleExpansion, actions} = this.props
    const expandedIcon = isExpanded ? 'arrowDown' : 'arrowUp'
    const expandedClassName = isExpanded ? ' expanded' : ''
    let partCategoryIcon = get(this.getPartCategoryPartType(), 'icon')
    partCategoryIcon = isNil(partCategoryIcon) ? iconNames.nonStock : partCategoryIcon

    return <>
      {!isNil(partCategory)
        ? (
          <div className={this.getClass('container')}>
            <div className={'header'}>
              <div className={'name'}>Category Details</div>
              <Button
                icon={expandedIcon}
                flat={true}
                size={12}
                onClick={onToggleExpansion}
              />
            </div>
            <div className={`content${expandedClassName}`}>
              <div className={'part-category'}>
                <div className={'name-wrapper'}>
                  <Icon name={partCategoryIcon}/>
                  <div className={'name'}>{partCategory.name}</div>
                </div>
                {getPartCategoryActionsMenu(actions, {category: partCategory})}
              </div>
              <div className={'total-parts'}>
                {getTitleForTotalItems(totalParts, 'part', 'parts')} under this category
              </div>
              <div className={'section-title'}>DEFAULTS</div>
              <ul className={'defaults'}>
                {this.getDefault('Template', get(this.getPartCategoryPartType(), 'label'))}
                {this.getDefault('Tax Code', this.getTaxCodeLabel())}
                {this.getDefault('Markup', this.getMarkup())}
              </ul>
            </div>
          </div>
        )
        : null
      }
    </>
  }
}

PartCategoryDetails.propTypes = {
  isExpanded: propTypes.bool.isRequired,
  partCategory: propTypes.object,
  totalParts: propTypes.number,
  taxCodes: propTypes.array.isRequired,
  partTemplates: propTypes.array.isRequired,
  onToggleExpansion: propTypes.func.isRequired,
  actions: propTypes.array,
}

PartCategoryDetails.defaultProps = {
  isExpanded: true,
  partCategory: nullPartCategory,
  totalParts: 0,
  taxCodes: [],
  partTemplates: [],
  actions: [],
}

export default PartCategoryDetails
